import { useEffect, useRef } from "react";
import { subscribe } from "@/lib/ipadLiveBus";

/**
 * Subscribe to server-pushed iPad live events.
 *
 *   useIpadLive((ev) => {
 *     if (ev.type === "charter.updated") load(true);
 *     if (ev.type.startsWith("booking.")) loadReservations(true);
 *   });
 *
 * The single iPad WebSocket is owned by `useIpadKillWatcher` (mounted
 * at the App root). This hook is a passive subscriber, so mounting it
 * on N pages doesn't open N sockets.
 */
export function useIpadLive(handler) {
  const ref = useRef(handler);
  useEffect(() => { ref.current = handler; }, [handler]);
  useEffect(() => subscribe((ev) => ref.current?.(ev)), []);
}
